import React, { useEffect } from 'react';
import Page from './../../components/Page';
import { Route } from 'react-router-dom';
import Matches from './Matches';
import Match from './Match';
import NewMatch from './NewMatch';
import NewFanGame from './NewFanGame';
import FanGame from './FanGame';
import Paths from '../../constants/paths';
import ErrorMessages from '../../components/ErrorMessages.js';
import { observer } from 'mobx-react-lite';

const MatchesTab = ({ store }) => {
    useEffect(() => {
        store.getTeams();
    }, [store]);

    return (
        <Page>
            <div style={{ marginLeft: '2.5%' }}>
                <ErrorMessages messages={store.error} />
            </div>
            <Route exact path={Paths.MATCHES}>
                <Matches store={store} />
            </Route>
            <Route exact path={Paths.MATCH}>
                <Match store={store} />
            </Route>
            <Route exact path={Paths.NEW_MATCH}>
                <NewMatch store={store} />
            </Route>
            <Route exact path={Paths.MATCH_NEW_FAN_GAME}>
                <NewFanGame store={store} />
            </Route>
            <Route exact path={Paths.MATCH_FAN_GAME}>
                <FanGame store={store} />
            </Route>
        </Page>
    );
};

export default observer(MatchesTab);
